import React, { useEffect, useMemo, useState } from "react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import SearchIcon from "@mui/icons-material/Search";
import { InputAdornment } from "@mui/material";
import { enqueueSnackbar } from "notistack";
import { useHistory } from "react-router-dom";
import Header from "../../../../components/Header";
import Container from "../../../../componentsv2/Container";
import Paper from "../../../../componentsv2/Paper";
import Button from "../../../../componentsv2/Button";
import Box from "../../../../componentsv2/Box";
import GridContainer from "../../../../componentsv2/GridContainer";
import GridItem from "../../../../componentsv2/GridItem";
import { Input } from "../../../../componentsv2/Input";
import { api } from "../../../../services/Api";
import getApiErrorMessage from "../../../../utils/getApiErrorMessage";
import TabelaMedicos from "./Components/TabelaMedicos";

export default function MedicosCare() {
  const history = useHistory();
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [busca, setBusca] = useState("");
  const [refreshTick, setRefreshTick] = useState(0);

  const atualizarTabela = () => {
    setRefreshTick(t => t + 1);
  };

  useEffect(() => {
    const carregar = async () => {
      setLoading(true);
      try {
        const {
          data: { data },
        } = await api.get("/v2/agendaCare/medicos_care");
        setRows(data || []);
      } catch (error) {
        enqueueSnackbar(getApiErrorMessage(error, "Erro ao carregar médicos!"), { variant: "error" });
      } finally {
        setLoading(false);
      }
    };
    carregar();
  }, [refreshTick]);

  const rowsFiltradas = useMemo(() => {
    const termo = busca.trim().toLowerCase();
    if (!termo) {
      return rows;
    }
    return rows.filter(row => {
      const nome = row?.nome?.toLowerCase() || "";
      const crm = row?.crm?.toLowerCase() || "";
      const estado = row?.estado?.toLowerCase() || "";
      const esp = (row?.especialidade ?? "").toString().toLowerCase();
      return nome.includes(termo) || crm.includes(termo) || estado.includes(termo) || esp.includes(termo);
    });
  }, [rows, busca]);

  return (
    <>
      <Header titulo="Médicos" />
      <Container>
        <Paper style={{ marginTop: "10px", padding: "1rem" }} elevation={2}>
          <GridContainer spacing={2}>
            <GridItem xs={12}>
              <Button onClick={() => history.push("/agendaCare")}>
                <ArrowBackIcon style={{ color: "#003399" }} />
              </Button>
            </GridItem>
            <GridItem xs={12}>
              <Box
                sx={{
                  display: "grid",
                  gridTemplateColumns: { xs: "1fr", md: "minmax(280px, 1fr) 180px" },
                  alignItems: "end",
                  gap: 2,
                }}
              >
                <Input
                  label="Pesquisar médico"
                  variant="standard"
                  fullWidth
                  value={busca}
                  onChange={event => setBusca(event.target.value)}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon style={{ color: "#8a919b" }} />
                      </InputAdornment>
                    ),
                  }}
                />
                <Button
                  variant="contained"
                  color="blue"
                  onClick={() => history.push("/agendaCare/CadastrarMedico")}
                  style={{ width: "100%" }}
                >
                  Cadastrar
                </Button>
              </Box>
            </GridItem>
            <GridItem xs={12}>
              <TabelaMedicos rows={rowsFiltradas} loading={loading} atualizarTabela={atualizarTabela} />
            </GridItem>
          </GridContainer>
        </Paper>
      </Container>
    </>
  );
}
